export const LOG_IN = "LOG_IN";

export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS";
export const LOG_IN_START = "LOG_IN_START";
export const LOG_IN_FAILURE = "LOG_IN_FAILURE";

export const LOG_OUT = "LOG_OUT";

export const SET_ROLE = "SET_ROLE";
